import styled from 'styled-components';

export const Wrapper = styled.div`
  input {
    height: 40px;
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: center;

    button {
      width: 130px;
    }
  }
`;
